
import { Controller } from "react-hook-form";
import { Checkbox } from '@fluentui/react';
import * as React from "react";


export const ControlledCheckboxField = (props) => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={props.rules}
      defaultValue={props.defaultValue || ""}
      render={({
        field: { name: fieldName },
        fieldState: { error },
      }) => (
        <Checkbox
          required={false}
          styles={{text:{fontWeight:'600'}}}
          onChange={props.onChange}
          name={fieldName}
          errorMessage={error && error.message}
          className="mt-3"
          {...props}
        />
      )}
    />
  );
};
